.wrapper {
  border-radius: 32px;
  background: #f3eddf;
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid #ded9ce;
}

.block {
  padding: 20px;
  border-bottom: 1px solid #ded9ce;
}

.block:last-child {
  border-bottom: none;
}

.block:last-child {
  .radioLabel {
    img {
      height: 16.5px;
    }
  }
}

.header {
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
}

.radio {
  display: none;
}

.radioLabel {
  position: relative;
  padding-left: 32px;
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  p {
    font-size: 17px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 0.068px;
  }

  img {
    height: 24px;
  }

  .gpl {
    height: 30.5px;
  }
}

.radioLabel::before {
  content: '';
  width: 24px;
  height: 24px;
  border: 2px solid #ddd9cf;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: 0.3s;
}

.radioChecked::before {
  background: url(./img/radio.png) no-repeat;
  background-position: center;
  background-size: contain;
  border: none; // Цвет рамки активной радиокнопки

  :global(.k9GreenTheme) & {
    background-image: url(./img/radioGreen.svg);
  }
}

// .radio:checked + .radioLabel::before {
//   background: url(./img/radio.png) no-repeat;
//   background-position: center;
//   background-size: contain;
//   border: none; // Цвет рамки активной радиокнопки
// }

.content {
  margin-top: 24px;
  display: none;
}

.content.active {
  display: block;
}

.secureText {
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0.045px;
  margin-top: 20px;
}

.secureImg {
  width: 77px;
  margin: 0 auto;
  margin-top: 10px;
}

.stripeImg {
  width: 96px;
  margin: 0;
}

.imgWrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 10px;

  .secureImg {
    margin-top: 0;
    margin: 0;
  }
}

.error {
  margin-top: 20px;
  font-size: 14px;
  line-height: 16px;
  color: #f76060;
}

.paypalWarnings {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: red;
  text-align: center;
  margin-top: 10px;
}

// Dark mode
:global body.dark {
  :local {
    .wrapper {
      background-color: #2a2928;
      border-color: #3E3C3A;
    }
    .block {
      border-color: #3E3C3A;
    }
    .radioLabel::before {
      content: '';
      width: 24px;
      height: 24px;
      border-color: #3E3C3A;
    }
    .radioLabel p {
      color: #fffbf2;
    }

    // .radioLabel img {
    //   filter: invert(1) grayscale(100%);
    // }

    .secureText {
      color: #fffbf2;
    }

    .imgWrapper .stripeImg {
      filter: invert(1) grayscale(100%);
    }
  }
}
